import { parseToRgba, rgba } from "color2k";

export function fade(color: string, percentage: number) {
  const [r, g, b] = parseToRgba(color);
  return rgba(r, g, b, percentage);
}
